<template>
<v-card>
  <v-card-title class='overline grey lighten-4 py-0' >
    Who would you like to share this form with?
    <v-spacer/>
    <v-btn small icon @click="$emit('close')" ><v-icon>close</v-icon></v-btn>
  </v-card-title>
  <v-divider/>
  <client-list
    :with-create='false'
    :show-list-initially='false'
    @relationshipselected='setRelationship' ></client-list>

  <share-card v-if="relId && url" :links="[url]" :relationship-id="relId" />

  <!-- <v-card-text>
    <center>
    <v-img v-if='qr'
      style='border:solid 2px black;'
      width='150px' height='150px' class='elevation-20 mb-4'
      :src='qr' >
    </v-img>
    </center>

    <copy-text-field v-if='url'
      :label="label"
      :hint="hint"
      :text-to-copy='url' />
  </v-card-text> -->

  <v-divider/>
  <v-footer class="caption" >
    <v-icon small >info</v-icon>
    To share a form with a client. From the client detail page:
    client info -> forms -> share a form
    <!-- <p>This will link their form submission to their profile in AppointmentGuru</p> -->
  </v-footer>
  <!-- <pre v-text="rel" /> -->
</v-card>
</template>
<script>
import ClientList from '@/components/client/ClientList.vue'
// import CopyTextField from '@/components/ui/CopyTextField'
import ShareCard from '@/components/cards/ShareCard.vue'

export default {
  name: 'ShareForm',
  components: {
    ClientList,
    // CopyTextField,
    ShareCard
  },
  props: {
    formId: { required: true }
  },
  data () {
    return {
      rel: null
    }
  },
  methods: {
    setRelationship (rel) {
      this.rel = rel
    }
  },
  computed: {
    fname () {
      return this.getObjectPath(this.rel, 'client.first_name', 'the client')
    },
    label () {
      return `Share this link with ${this.fname}`
    },
    hint () {
      return `Important: This is a custom link for ${this.fname}. Do not share this link with anyone else`
    },
    url () {
      if (this.rel) {
        return 'https://form.jotform.com/' + this.formId + '?relationship_id=' + this.rel.id
      }
      return null
    },
    relId () { return this.getObjectPath(this.rel, 'id') },
    qr () {
      if (this.url) {
        let base = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data='
        return base + this.url
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ShareForm.vue?58d8b754